import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  default: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function Spinner({ size = 'default', className }: SpinnerProps) {
  return (
    <Loader2
      className={cn('animate-spin text-[hsl(var(--muted-foreground))]', sizeClasses[size], className)}
    />
  );
}
